import React from 'react';
import { Info, Ruler } from 'lucide-react';
import { useFormContext } from '../FormContext';
import { FormStep } from '../FormStep';
import { InfoBox } from '../InfoBox';
import { FormButtons } from '../FormButtons';
export const DimensionsStep: React.FC = () => {
  const {
    formData,
    handleChange,
    goToPreviousStep,
    goToNextStep
  } = useFormContext();
  return <FormStep title="Afmetingen" description="Geef de afmetingen van uw tuin en gewenste veranda aan." isActive={true} data-id="element-845">
      <div className="space-y-6 mb-10" data-id="element-846">
        <div data-id="element-847">
          <label className="block text-white/90 font-medium mb-2" data-id="element-848">
            Tuin in breedte (cm) *
          </label>
          <div className="relative" data-id="element-849">
            <input type="text" inputMode="numeric" value={formData.gardenWidth} onChange={handleChange} name="gardenWidth" placeholder="Bijv. 500" className="w-full px-4 py-3 rounded-md border border-white/30 bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#CDA735] focus:border-transparent text-white placeholder-white/50" data-id="element-850" />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-851">
              <Ruler className="h-5 w-5 text-white/50" data-id="element-852" />
            </div>
          </div>
        </div>
        <div data-id="element-853">
          <label className="block text-white/90 font-medium mb-2" data-id="element-854">
            Diepte van veranda (cm) *
          </label>
          <div className="relative" data-id="element-855">
            <input type="text" inputMode="numeric" value={formData.verandaDepth} onChange={handleChange} name="verandaDepth" placeholder="Bijv. 300" className="w-full px-4 py-3 rounded-md border border-white/30 bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#CDA735] focus:border-transparent text-white placeholder-white/50" data-id="element-856" />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-857">
              <Ruler className="h-5 w-5 text-white/50" data-id="element-858" />
            </div>
          </div>
        </div>
      </div>
      <InfoBox icon={<Info data-id="element-860" />} data-id="element-859">
        Deze afmetingen helpen ons bij het maken van een nauwkeurige offerte.
        Tijdens het adviesgesprek kunnen we deze nog aanpassen.
      </InfoBox>
      <FormButtons onPrevious={goToPreviousStep} onNext={goToNextStep} isNextDisabled={!formData.gardenWidth || !formData.verandaDepth} data-id="element-861" />
    </FormStep>;
};